import {  UPDATE_NAVS } from './navigationTypes';
import {RoutesInterfaceNavigations} from './../../RoutesNavigations'


const initialState={
    navIndex: RoutesInterfaceNavigations
}

const navigationReducer = (state= initialState, action )=>{
    // console.log(state, action);
    switch(action.type){
        case UPDATE_NAVS: 
        //return
        // {
        //     ...state,
        //     ...action.payload
        // }
        {  
            let payload= action.payload;
            console.log(state);
            let ot= state.navIndex.filter(item=> {
                console.log("check",item.href , payload.href, item.href === payload.href)
                if(item.href === payload.href){
                   return payload;
                }else{
                    return item
                } 
            } );
            //console.log("@update",state);
           return {
            ...state, ...{navIndex: ot}
           }

        }
        default: return state
    }
    // return state
}
export default navigationReducer